import {
    ASSIGNMENT_ID_PARAM,
    ASSIGNMENT_TOKEN_PARAM,
    FILE_TOKEN_PARAM,
    IS_ADDING_TO_EXISTING_PATTERN_PARAM,
    IS_NON_LBE_PATTERN_PARAM,
    LAYER_ID_PARAM,
    LINES_PARAM,
    PATTERN_ID_PARAM,
    PROBLEM_SET_ID_PARAM,
    RESET_PASSWORD_CODE_PARAM,
    SUBMISSION_ID_PARAM,
    T_PARAM,
    TOKEN_PARAM,
    USER_ID_PARAM,
    VERSION_ID_PARAM,
} from '../constants/query-params'
import useQueryParam from '../hooks/useQueryParam'

export const useAssignmentId = () => useQueryParam(ASSIGNMENT_ID_PARAM)
export const useSubmissionId = () => useQueryParam(SUBMISSION_ID_PARAM)
export const useLayerId = () => useQueryParam(LAYER_ID_PARAM)
export const usePatternId = () => useQueryParam(PATTERN_ID_PARAM)
export const useLines = () => useQueryParam(LINES_PARAM)
export const useAssignmentToken = () => useQueryParam(ASSIGNMENT_TOKEN_PARAM)
export const useIsAddingToExistingPattern = () => useQueryParam(IS_ADDING_TO_EXISTING_PATTERN_PARAM)
export const useToken = () => useQueryParam(TOKEN_PARAM)
export const useT = () => useQueryParam(T_PARAM)
export const useFileToken = () => useQueryParam(FILE_TOKEN_PARAM)
export const useResetPasswordCode = () => useQueryParam(RESET_PASSWORD_CODE_PARAM)
export const useUserId = () => useQueryParam(USER_ID_PARAM)
export const useProblemSetId = () => useQueryParam(PROBLEM_SET_ID_PARAM)
export const useVersionId = () => {
    const versionId = useQueryParam(VERSION_ID_PARAM)
    return versionId ? Number(versionId) || versionId : versionId
}
export const useInNonLbePattern = () => useQueryParam(IS_NON_LBE_PATTERN_PARAM)

export const getQueryParam = param => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(param)
}
